import React from 'react';
import Slider from 'react-slick';

const MobileSlides = () => (
  <div className={'wdm__mobile-slider--container'}>
    <Slider {...MobileSlides.sliderSettings}>
      <div className={'wdm__slide'}>
        <img src={this.props.photos[0]} />
      </div>
      <div className={'wdm__slide'}>
        <img src={this.props.photos[1]} />
      </div>
      <div className={'wdm__slide'}>
        <img src={this.props.photos[2]} />
      </div>
    </Slider>
  </div>
);

MobileSlides.sliderSettings = {
  className: 'wdm__mobile-slider',
  dotsClass: 'slick-dots slick-pagination',
  arrows: false,
  dots: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 4000,
  adaptiveHeight: false,
  pauseOnHover: false,
  pauseOnDotsHover: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export default MobileSlides;
